<!--<div class="page-load-animation"></div>-->
<!-- <vr-route-handler></vr-route-handler> -->
<!-- Everything related to Layout is found in core/layout/layout.component.ts -->
<router-outlet></router-outlet>
<!-- <app-quick-links-floating></app-quick-links-floating> -->
